/* 封装一些方便的表单校验方法，基于http://jaywcjlove.github.io/validator.js */
/* 导出错误信息 */
window.exErrors = function(error, $formName, callback, that, is_top) {
    var $form = $("#" + $formName);
    $form.find(".form-error").remove();
    $form.find(".validation-failed").removeClass('validation-failed');
    if (error.length > 0) {
        for (var i = 0; i < error.length; i++) {
            var errStr = '<p class="form-error" style="display:block;">' + error[i].message + "</p>"; //错误信息
            var errIpt = $form.find("[name='" + error[i].name + "']"); //这个表单下的 而非其他表单

            errIpt.addClass('validation-failed');
            var errorBox = errIpt.parent();
            if (errIpt.prop("type") == "radio") {
                errorBox = errIpt
                    .parent()
                    .parent();
                    if($formName=='product-detail_form'){//针对这个表单下的多选项
                        errorBox.after(errStr);
                        continue;
                    }

            } else if (errIpt.prop("type") == "checkbox") {
                errorBox = errIpt
                    .parent()
                    .parent();
                    if($formName=='returncustomer-form'){//针对这个表单下的多选项
                        errorBox = errIpt.parent().parent().parent();
                        }
            }else if($formName=='share-footer-form'){
                errorBox = errIpt
                    .after(errStr);
            }
            /* 未明确是否有用 */
            // if(error[i].element.length>1){
            //     for (var j = 0; j < error[i].element.length; j++) {
            //         var errIpt=$(error[i].element);
            //         var errorBox = errIpt.parent().parent();
            //         if (!errorBox.children().hasClass("form-error")) {
            //             //如果有报错就不重复添加报错了
            //             errorBox.append(errStr);
            //             // errIpt.after(errStr);
            //         }
            //     }
            //     continue;
            // }
            if (!errorBox.children().hasClass("form-error")) {
                //如果有报错就不重复添加报错了
                errorBox.append(errStr);
                // errIpt.after(errStr);
            }

        }
        if (is_top) {
            if (that) {
                if (that == 1) {
                    formValfidationReturn($formName);
                    return;
                }
                if (that == 2) {
                    return;
                }
                if (that.siblings(".form-error")[0]) {
                    formValfidationReturn($formName);
                    return;
                }
            }
        }
    } else if (typeof callback == "function") {
        callback();
    }
};
/*end 导出错误信息 */

/* 进行校验 */
window.valivali = function(options, fieldArr, callback) {
    /*
options={
    formId:'',//表单id，不带#
    isTop:'',//是否开启回到首个错误
    flagWindow:'',//flagWindow:  弹窗产品属性验证 true, 非弹窗产品属性验证: false;
}
options 如果是string 就默认为formid;
*/
if(typeof options =='object'){
    var $formName= options.formId;
    var is_top= options.isTop;
    var flagWindow=options.flagWindow;
}else{
    var $formName= options;
}
var $form = $("#" + $formName);
var first = true;
if(is_top==undefined){
    is_top=true;
}
var _validator = new Validator($formName, fieldArr).validate();
if($form.parents('.windowRegister')){
    exErrors(_validator.errors, $formName, callback, 2, is_top);
}else{
    exErrors(_validator.errors, $formName, callback, 1, is_top);
}
/* 只需要执行一次 */
if (first) {
    $form.find('input[type="text"],input[type="password"],select,textarea').on("keyup change", function() {
        var that = $(this);
        var obj = _validator.validate();
        exErrors(obj.errors, $formName, function() {}, that, is_top);
    });
    first = false;
}
/* end 只需要执行一次 */
return _validator;
};

window.validatorInfo = function($formName, fieldArr, callback, is_top) {
    var $form = $("#" + $formName);
    var first = true;
    if(is_top==undefined){
        is_top=true;
    }
    var _validator = new Validator($formName, fieldArr).validate();
    exErrors(_validator.errors, $formName, callback, 1, is_top);
    /* 只需要执行一次 */
    if (first) {
        $form.find('input[type="text"],input[type="password"],select,textarea').on("keyup change", function() {
            var that = $(this);
            var obj = _validator.validate();
            exErrors(obj.errors, $formName, function() {}, that, is_top);
        });
        first = false;
    }
    /* end 只需要执行一次 */
    return _validator;
};
/* end 进行校验 */
/* 回到第一个的错误信息位置 */
window.formValfidationReturn = function(element) {
    var errorElement = $("#" + element).find(".form-error") ? $("#" + element).find(".form-error") : "";
    if (errorElement.length != 0) {
        var offsetTop = errorElement
            .eq(0)
            .parent()
            .offset().top;

        if (offsetTop > 0) {
            if ($(".header").hasClass("hasXker")) {
                offsetTop = offsetTop - 100;
            } else {
                offsetTop = offsetTop - 70;
            }
            window.scrollTo(0, offsetTop);
        } else {
            window.scrollTo(0, 0);

        }
    }
};
/*end 回到第一个的错误信息位置 */
/* Form validation returned error end */

/* 校验域 */
window.field =
    [
        {
            name: "reward-point",
            display: "This is not number.",
            rules: "is_money|required"
        },
        {
            name: "coupon-code",
            display: "This is not number.",
            rules: "is_money|required"
        },
        {
            name: "order-comment",
            display: "This is mandatory.",
            rules: "required"
        },
        {
            name: "postCode",
            display: "This is mandatory.",
            rules: "required"
        },
        {
            name: "req",
            display: "This is mandatory.",
            rules: "required"
        },
        {
            name: "firstname",

            display: "This is mandatory.",
            rules: "required"
        },
        {
            name: "lastname",
            display: "This is mandatory.",
            rules: "required"
        },
        {
            name: "street",
            display: "This is mandatory.",
            rules: "required"
        },
        {
            name: "city",
            display: "This is mandatory.",
            rules: "required"
        },
        {
            name: "state",
            display: "This is mandatory.",
            rules: "required"
        },
        {
            name: "country",
            display: "This is mandatory.",
            rules: "required"
        },
        {
            name: "zip-postal",
            display: "This is mandatory.",
            rules: "required"
        },
        {
            name: "comment",
            display: "This is mandatory.",
            rules: "required"
        },
        {
            name: "address",
            display: "This is mandatory.",
            rules: "required"
        },
        {
            name: "billing[country_id]",
            display: "This is mandatory.",
            rules: "required"
        },
        {
            name: "billing[region_id]",
            display: "This is mandatory.",
            rules: "required"
        },
        {
            name: "alphanumeric",
            rules: "alpha_numeric"
        },
        {
            name: "password",
            display: "This is mandatory.",
            rules: "required|min_length(6)"
        },
        {
            name: "confirmation",
            display: "This is mandatory.|Please make sure your passwords match.",
            rules: "required|same(new-password)"
        },
        {
            name: "email",
            display: "This is mandatory.|Please enter a valid email address. For example johndoe@domain.com.",
            rules: "required|is_email"
        },
        {
            name: "login_username",
            display: "This is mandatory.|Please enter a valid email address. For example johndoe@domain.com.",
            rules: "required|is_myemail"
        },
        // {
        //     name: "phoneNum",
        //     display: "min length",
        //     rules: "min_length[8]|numeric"
        // },
        {
            name: "tos_checkbox",
            display: "This is mandatory.",
            rules: "required"
        },
        {
            name: "phoneNum",
            display: "This is mandatory.|Please enter a valid telephone.",

            rules: "required|is_phone"
        }
    ];
